export default __webpack_public_path__ + "static/media/subscribe.3fa801a5.svg";